interface ITransform {
  position: any;
  scale: any;
}

interface IConfig {
  width: number;
  distance: number;
  firstPoint: any;
  secondPoint: any;
}

export class ChangeStairsTransformationAction {
  readonly childrenTransformations: Array<ITransform>;
  readonly config: IConfig;

  constructor(childrenTransformations: Array<ITransform>, config: IConfig) {
    Object.assign(this, {childrenTransformations, config});
  }

}



// WEBPACK FOOTER //
// ./src/app/services/eventLog/actions/ChangeStairsTransformationAction.ts